export const SET_SELECTED_ITEM = 'SET_SELECTED_ITEM';
export const SET_RELATIONS = 'SET_RELATIONS';
export const SET_SOURCES = 'SET_SOURCES';
export const SET_TABLES = 'SET_TABLES';
export const SET_COLUMNS = 'SET_COLUMNS';
export const SET_COLUMNS_LOADING = 'SET_COLUMNS_LOADING';
export const SET_SOURCE_TABLES = 'SET_SOURCE_TABLES';
export const SET_SOURCE_TABLES_LOADING = 'SET_SOURCE_TABLES_LOADING';
export const SET_ENTITY_RELATIONS = 'SET_ENTITY_RELATIONS';
export const SET_ENTITY_RELATIONS_LOADING = 'SET_ENTITY_RELATIONS_LOADING';